import React, { FC } from 'react'
import { ButtonContainer } from './styles'

export const Button: FC<HTMLButtonElement> = (props) => {
  return <ButtonContainer {...props} />
}
